module.exports = __webpack_public_path__ + "static/media/Diagnose.23cc1ee4.svg";